import Dropdown from "rc-dropdown";
import "rc-dropdown/assets/index.css";
import Menu from "rc-menu";
import React from "react";
import styled from "styled-components";
import hooks from "./hooks";
import { AppSwitcherProps } from "./types";

const { useAppSwitcher } = hooks;
const defaultAppSwitcherImageUrl =
  "https://storage.googleapis.com/develop-teko-storage/media/image/2023/1/3/d422ac2f-2f5e-4da1-9bb2-398c3d971372/app-switcher.png";
const appiInfo = {
  id: 0,
  name: "Merchant Marketplace",
  description: "Merchant Marketplace Homepage",
  iconUrl:
    "https://storage.googleapis.com/develop-teko-storage/media/image/2023/1/10/c5b3789e-3420-4fa9-a026-6edcc0b7d61c/Untitled-2.png",
};

const AppSwitcher: React.FC<AppSwitcherProps> = (props) => {
  const { appSwitcherItems } = useAppSwitcher(props.apiMerchantBffUrl);

  const menu = (
    <StyledMenu>
      {[appiInfo, ...appSwitcherItems].map((app) => (
        <Menu.Item key={app.id}>
          <a
            target="_self"
            rel="noopener noreferrer"
            href={
              app.id === 0
                ? props.baseMMUrl
                : `${props.baseMMUrl}/accounts/login/app/${app.id}`
            }
          >
            <WrapperMenuItem>
              <WrapperMenuItemImg
                style={{
                  ...props.imgDropdownStyles,
                  backgroundColor: !app.iconUrl ? "#ccc" : "transparent",
                }}
              >
                {app.iconUrl && <CircleImage src={app.iconUrl} />}
              </WrapperMenuItemImg>
              <WrapperMenuItemContent>
                <WrapperMenuItemName>{app.name}</WrapperMenuItemName>
                <WrapperMenuItemDescription>
                  {app.description}
                </WrapperMenuItemDescription>
              </WrapperMenuItemContent>
            </WrapperMenuItem>
          </a>
        </Menu.Item>
      ))}
    </StyledMenu>
  );

  return (
    <Dropdown
      trigger={["click"]}
      overlay={menu}
      animation="slide-up"
      placement={props.placement || "bottomLeft"}
    >
      <WrapperDropdownTrigger style={props.dropdownStyles}>
        <CircleImage
          style={props.imgDropdownStyles}
          src={props.customImageUrl || defaultAppSwitcherImageUrl}
        ></CircleImage>
      </WrapperDropdownTrigger>
    </Dropdown>
  );
};

export default AppSwitcher;

const StyledMenu = styled(Menu)`
  border: none !important;
  max-height: 450px;
  overflow-y: auto;
`;

const WrapperMenuItem = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 8px;
  margin-bottom: 8px;
  padding: 8px;

  &:hover {
    background-color: #f5f5f5;
  }
`;

const WrapperMenuItemContent = styled.div`
  margin-left: 16px;
`;

const WrapperMenuItemName = styled.div`
  color: #333333;
`;

const WrapperMenuItemDescription = styled.div`
  color: #adadad;
  max-width: 200px;
  white-space: pre-wrap;
`;

const CircleImage = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 50%;
`;

const WrapperMenuItemImg = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
`;

const WrapperDropdownTrigger = styled.span`
  cursor: pointer;
`;
